/** 图片特效运行时常量、默认配置和结果画布尺寸计算。 */
import { getLocaleStore } from '@/i18n/index';
import { IImageEffectShadowType, ImageEffectStrokeType, type IImageLayerProps } from '@/version-types';

/** 普通图片特效结果画布相对原图的默认扩展倍数。 */
export const ImgEffectResultImgSize = 1.4;

/** complexBridge 的滤镜标识。 */
export const ComplexBridgeFilterID = 'ComplexBridge';

/**
 * 计算图片特效结果画布的扩展倍数
 *
 * @param imageData - 图片图层数据
 * @returns 普通特效返回 1.4，存在外扩投影时返回 4
 */
export const getImageEffectResultImgSize = (imageData: IImageLayerProps) => {
    if (!imageData || !imageData.effect) {
        return 1.4;
    }

    const { effect } = imageData;

    if (effect?.shadow && effect?.shadow?.length > 0 && effect.screenshotUrl && !effect.effectPosition) {
        const shadow = effect.shadow.find((item) => {
            return item.type !== IImageEffectShadowType.base && item.type !== undefined;
        });

        // 除了基础投影外的投影需要4倍的图层大小
        if (shadow) {
            return 4;
        }
    }

    // 普通特效只需要1.4倍图层大小
    return 1.4;
};

/** @returns 默认描边配置 */
export const getDefaultStrokeValue = () => ({
    color: '#2773ffff',
    width: 0.2,
    hidden: false,
    strokeType: ImageEffectStrokeType.normal,
});

/** @returns 默认外发光配置 */
export const getDefaultGlowValue = () => ({
    color: '#ffff007f',
    hidden: false,
    width: 0.3,
});

/** @returns 默认投影配置 */
export const getDefaultShadowValue = () => ({
    color: '#2773ff99',
    blur: 0.3,
    hidden: false,
    x: -0.02,
    y: 0,
});

/** @returns 已国际化的描边类型选项 */
export const getStrokeTypeOptions = () => {
    const { $t } = getLocaleStore();
    return [
        {
            url: 'strokeType0',
            label: $t((v) => v.imageEffectPanel.constants.normal),
            value: ImageEffectStrokeType.normal,
        },
        {
            url: 'strokeType1',
            label: $t((v) => v.imageEffectPanel.constants.outSolidLine),
            value: ImageEffectStrokeType.outSolidLine,
        },
        {
            url: 'strokeType2',
            label: $t((v) => v.imageEffectPanel.constants.outDashedLine),
            value: ImageEffectStrokeType.outDashedLine,
        },
        {
            url: 'strokeType3',
            label: $t((v) => v.imageEffectPanel.constants.tornPaper),
            value: ImageEffectStrokeType.tornPaper,
        },
    ];
};

/** @returns 空图片特效配置 */
export const getEmptyEffect = () => ({
    effectAlpha: 1,
    glow: [],
    shadow: [],
    stroke: [],
    screenshotUrl: '',
});
